import request from '@/utils/request'

// 岗位删除
export function roleDelete(data) {
  return request({
    url: '/sys/role/delete',
    method: 'post',
    data
  })
}

// 岗位详情
export function roleDetail(params) {
  return request({
    url: `/sys/role/info/${params}`,
    method: 'get'
  })
}

// 岗位修改
export function roleUpdate(data) {
  return request({
    url: '/sys/role/update',
    method: 'post',
    data
  })
}

// 岗位新增
export function roleSave(data) {
  return request({
    url: '/sys/role/save',
    method: 'post',
    data
  })
}
